import { render } from "./ComanderoView.vue?vue&type=template&id=48b2e4cc&scoped=true"
import script from "./ComanderoView.vue?vue&type=script&lang=js"
export * from "./ComanderoView.vue?vue&type=script&lang=js"

import "./ComanderoView.vue?vue&type=style&index=0&id=48b2e4cc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48b2e4cc"]])

export default __exports__